<script lang="ts" setup>
import { faPen } from '@fortawesome/pro-regular-svg-icons'
</script>

<template>
  <GIconButton label="Edit" :icon="faPen"/>
</template>
